import { Row, Table, Col, Card, Select, Popover, Tag } from 'antd';
import React, { useState } from 'react';
import {
  CardTitleText,
  MenuItemText,
  StandardTableRowText,
  TableColumnTitle,
} from '../../../../../../../shared/globalStyling/styledText';
import {
  //formatCurrency2SigFig,
  formatNumber,
  formatNumber2SigFig,
} from '../../../../../../../../core/utils/campaigns';
import LineItemsDonut from './LineItemsDonut';
import LineItemsModal from './LineItemsModal';
import { randomColors } from '../../../../../../../../core/utils/colors';
import { TagWithConfig } from '../../../../../shared/StatusTag';
import { tagStatusConfig } from '../../../../utils';

const { Option } = Select;

const Style = {
  campaignCardStyle: {
    margin: 5,
    padding: 2,
    height: 340,
    backgroundColor: '#fff',
  },
  campaignCardStyleCreatives: {
    backgroundColor: '#fff',
  },
  title: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  xs: {
    span: 24,
    offset: 0,
  },
  sm: {
    span: 24,
    offset: 0,
  },
  md: {
    span: 16,
    offset: 0,
  },
  lg: {
    span: 16,
    offset: 0,
  },
  xl: {
    span: 16,
    offset: 0,
  },
  xsPie: {
    span: 24,
    offset: 0,
  },
  smPie: {
    span: 24,
    offset: 0,
  },
  mdPie: {
    span: 8,
    offset: 0,
  },
  lgPie: {
    span: 8,
    offset: 0,
  },
  xlPie: {
    span: 8,
    offset: 0,
  },
};

const {
  xs,
  sm,
  md,
  lg,
  xl,
  xsPie,
  smPie,
  mdPie,
  lgPie,
  xlPie,
  campaignCardStyle,
  campaignCardStyleCreatives,
} = Style;

const options = [
  {
    value: 'impressions',
    text: 'Ad Impressions',
  },
  {
    value: 'clicks',
    text: 'Clicks',
  },
];
const Extra = ({ setLineItemDimension }) => {
  return (
    <Row gutter={[10, 0]} justify="space-between" align="bottom">
      <Col>
        <CardTitleText text={'Breakdown'} />
      </Col>
      <Col>
        <Row align="bottom">
          <TableColumnTitle text={'Show By:'} />
          <Select
            defaultValue={options[0].value}
            onChange={(value) => {
              setLineItemDimension(value);
            }}
          >
            {options.map((option, index) => {
              return (
                <Option key={index} value={option.value}>
                  <MenuItemText text={option.text} />
                </Option>
              );
            })}
          </Select>
        </Row>
      </Col>
    </Row>
  );
};

const LineItemsCard = ({ data }) => {
  const [lineItemDimension, setLineItemDimension] = useState('impressions');
  const columns = [
    {
      title: <TableColumnTitle text={'Name'} />,
      dataIndex: 'lineItemName',
      key: 'lineItemName',
      align: 'left',
      width: '20%',
      render: (lineItemName) => (
        <Popover trigger="hover" title={lineItemName}>
          <StandardTableRowText text={lineItemName} />
        </Popover>
      ),
    },
    {
      title: <TableColumnTitle text={'Flight Dates'} />,
      dataIndex: 'lineItemName',
      key: 'lineItemName',
      align: 'left',
      width: '20%',
      render: (_, record) => {
        return <StandardTableRowText text={`${record.startDate} - ${record.endDate}`} length={6} />;
      },
    },
    {
      title: <TableColumnTitle text={'Status'} />,
      dataIndex: 'status',
      key: 'status',
      align: 'center',
      render: (status) => {
        return <TagWithConfig {...tagStatusConfig[status || 'PLAY']} />;
      },
    },
    {
      title: <TableColumnTitle text={'Value Add'} />,
      dataIndex: 'valueAdd',
      key: 'valueAdd',
      align: 'center',
      render: (_, record) => {
        return record.valueAdd === true ? (
          <Tag
            style={{
              backgroundColor: '#F3E8FF',
              borderRadius: '25px',
              color: '#9333EA',
              width: '59%',
              textAlign: 'center',
            }}
          >
            Yes
          </Tag>
        ) : null;
      },
    },
    // Commented out budget column we need to add permission to view budget
    // {
    //   title: <TableColumnTitle text={"Budget"} />,
    //   dataIndex: "budget",
    //   key: "budget",
    //   align: "left",
    //   width: "25%",
    //   render: budget => (
    //     <StandardTableRowText text={formatCurrency2SigFig(budget || 0)} />
    //   ),
    // },
    {
      title: <TableColumnTitle text={'Impressions'} />,
      dataIndex: 'impressions',
      key: 'impressions',
      align: 'left',
      render: (impressions) => <StandardTableRowText text={formatNumber(impressions)} />,
    },
    {
      title: <TableColumnTitle text={'Clicks'} />,
      dataIndex: 'clicks',
      key: 'clicks',
      align: 'left',
      render: (clicks) => <StandardTableRowText text={formatNumber(clicks)} />,
    },
    {
      title: <TableColumnTitle text={'CTR'} />,
      dataIndex: 'ctr',
      key: 'ctr',
      align: 'left',
      render: (ctr) => <StandardTableRowText text={formatNumber2SigFig(ctr) + `%`} />,
    },
    {
      title: <TableColumnTitle text={'Action'} />,
      align: 'left',
      render: (_, record) => {
        return (
          <LineItemsModal
            byDate={record.byDate}
            summary={{
              startDate: record.startDate,
              endDate: record.endDate,
              impressions: record.impressions,
              clicks: record.clicks,
              ctr: record.ctr,
            }}
            creatives={record.creatives}
            publishers={record.publishers}
            segments={record.segments}
            name={record.lineItemName}
            status={record.status}
          />
        );
      },
    },
  ];
  return (
    <Row gutter={35}>
      <Col xs={xs} sm={sm} md={md} lg={lg} xl={xl}>
        <Card
          style={campaignCardStyleCreatives}
          headStyle={{ borderWidth: '2px' }}
          bodyStyle={{ padding: 0 }}
          title={<CardTitleText text={'Line Items'} />}
        >
          <Table columns={columns} dataSource={data} scroll={{ x: 200, y: 400 }} />
        </Card>
      </Col>
      <Col xs={xsPie} sm={smPie} md={mdPie} lg={lgPie} xl={xlPie}>
        <Card
          style={campaignCardStyleCreatives}
          bodyStyle={{ padding: 0, height: '100%' }}
          headStyle={{ borderWidth: '2px' }}
          title={<Extra setLineItemDimension={setLineItemDimension} />}
        >
          <LineItemsDonut
            data={data.map((d) => ({
              ...d,
              value: d.lineItemName,
              color: randomColors(),
            }))}
            height={campaignCardStyle.height}
            selectedDimension={lineItemDimension}
          />
        </Card>
      </Col>
    </Row>
  );
};

export default LineItemsCard;
